import React, {Component, useEffect} from 'react';
import Grid from "@mui/material/Grid";
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import TextareaAutosize from "@mui/material/TextareaAutosize";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import {useDispatch, useSelector} from "react-redux";
import {initNoticeForm, selNoticeForm} from "../../../stores/notice/slice";
import {ContainerHeader} from "../../module";
import TextField from "@mui/material/TextField";
import DatePicker from "react-datepicker2";
import moment from "moment-jalaali";
import Autocomplete from "@mui/material/Autocomplete";
import {onNoticeFormChange} from "../../../stores/notice/slice";
import {useHistory, useParams} from "react-router";
import useValidation from "../../../validation/useValidation";
import {FormNoticeInit, noticeValidations} from "../../../stores/notice/model";
import {notification} from "../../functions/notification/notificationFunction";
import {createNotice, editNotice, getNoticeById} from "../../../stores/notice/thunk";

export default function Notice() {

    const notice = useSelector(selNoticeForm);

    const { title, message, start_date, end_date, type, status } = notice;

    const dispatch = useDispatch();
    const {id} = useParams();
    const history = useHistory();

    const {errors, checkFiled, checkValidation} = useValidation({
        data: noticeValidations,
        key: 'noticeForm',
    });

    function setParametersMain(event) {
        const {value, name} = event.target;
        checkFiled(name, value);
        dispatch(onNoticeFormChange({name, value}))
    }

    function backToUsers() {
        history.push('/notices');
    }

    function setTime(e, name) {
        // const value = moment(e).format(`YYYY-MM-DD`)
        const value = moment(e).format(`jYYYY/jMM/jDD HH:mm:ss`)
        checkFiled(name, value);
        dispatch(onNoticeFormChange({name, value: value}))
        // setStaticState(prevState => (
        //     {
        //         ...prevState, [name]: e.format(`jYYYY/jMM/jDD`),
        //         [`dateForSend`]: e.format(`YYYY/MM/DD`)
        //     }
        // ));
    }

    const redirectToNotices =()=> history.push("/notices")

    async function addNotice(){
        const data = {
            title: title,
            message: message,
            start_date: start_date,
            end_date: end_date,
            type: 1,
            status: status,
        }

        const check = await checkValidation(data);
        if (!check) return dispatch(notification("error","خوش آمدید",<h3>فیلد های قرمز رنگ را پر کنید</h3>,false))
        dispatch(createNotice(data, redirectToNotices))
    }

    async function putNotice(){
        const data = {
            title: title,
            message: message,
            start_date: start_date,
            end_date: end_date,
            type: 1,
            status: status,
        }

        const check = await checkValidation(data);
        if (!check) return dispatch(notification("error","خوش آمدید",<h3>فیلد های قرمز رنگ را پر کنید</h3>,false))
        dispatch(editNotice(id, data, redirectToNotices))
    }

    useEffect(() => {
        id ?
            dispatch(getNoticeById({id}))
            :
            dispatch(initNoticeForm(FormNoticeInit))
        return ()=>{
            dispatch(initNoticeForm(FormNoticeInit))
        }
    }, [id]);

    return (
        <Grid item xs={11} sm={12}
              className="w-100 d-flex flex-column DivParentCreateProduct ContentCreateAttribute">
            <ContainerHeader
                data={{
                    filter: false,
                    backBtn: true,
                }}
                headerTitle="افزودن کاربر"
                backBtnTitle="بازگشت"
                backBtnAction={backToUsers}
                // filterAction={(value) => {
                //     handleSearch(value);
                // }}
            />
            <Paper className="parentContentCreateProduct">
                <div className="w-100">

                    <div className="w-100">
                        <div className="d-flex flex-column">
                            <Grid container spacing={2}
                                  className="d-flex flex-wrap divParentContentBasicInformation mt-4">
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <TextField
                                        label={'عنوان'}
                                        variant="outlined"
                                        name={'title'}
                                        value={notice?.title}
                                        error={errors.title}
                                        className={`w-100`}
                                        onChange={setParametersMain}
                                    />
                                </Grid>
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <DatePicker
                                        isGregorian={false}
                                        className={`DatePickerUserPanel ${errors.start_date && "redBorder"}`}
                                        // timePicker={false}
                                        value={ start_date !== null ? moment(start_date , 'jYYYY/jMM/jDD HH:mm:ss') : null }
                                        onChange={(e) => setTime(e, 'start_date')}
                                        placeholder={`از تاریخ`}
                                    />
                                </Grid>
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <DatePicker
                                        isGregorian={false}
                                        className={`DatePickerUserPanel ${errors.end_date && "redBorder"}`}
                                        // timePicker={false}
                                        value={ end_date !== null ? moment(end_date , 'jYYYY/jMM/jDD HH:mm:ss') : null }
                                        onChange={(e) => setTime(e, 'end_date')}
                                        placeholder={`تا تاریخ`}
                                    />
                                </Grid>
                                <Grid item
                                      xs={12} lg={6} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={notice?.status === 1}
                                                onChange={(e)=> {
                                                    const value = e.target.checked ? 1 : 0
                                                    dispatch(onNoticeFormChange({
                                                        name: "status",
                                                        value: value
                                                    }))
                                                }
                                                }
                                            />
                                        }
                                        label="وضعیت"
                                    />
                                </Grid>
                                <Grid item
                                      xs={12} lg={12} xl={12}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <TextField
                                        id="standard-basic"
                                        placeholder="متن پیام"
                                        multiline
                                        error={errors.message}
                                        name="message"
                                        value={notice?.message}
                                        onChange={setParametersMain}
                                        variant="outlined"
                                        InputProps={{
                                            inputComponent: TextareaAutosize,
                                            inputProps: {
                                                style: {
                                                    resize: "auto"
                                                }
                                            }
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                        <Button
                            variant="contained"
                            onClick={id ? putNotice : addNotice}
                            className="continuationButtonCreateProduct mr-3 mt-5"
                        >
                            {id ? "ویرایش": "ایجاد"}
                        </Button>
                    </div>
                </div>
            </Paper>
        </Grid>
    );
}

